import { render } from "./ScansionaColliEntrataForm.vue?vue&type=template&id=a09865dc"
import script from "./ScansionaColliEntrataForm.vue?vue&type=script&lang=js"
export * from "./ScansionaColliEntrataForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__